import { Configuration, PopupRequest } from "@azure/msal-browser";

// MSAL configuration for multi-tenant authentication
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "", // Your App Registration Client ID
    authority: "https://login.microsoftonline.com/common", // 'common' enables multi-tenant
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// Scopes for user authentication
export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "User.Read.All", "Group.Read.All", "openid", "profile", "email"],
};

// API configuration
export const apiConfig = {
  apiUrl: process.env.REACT_APP_API_URL || "",
};
